import React, { useState } from "react";
import { makeStyles, Grid, Box } from "@material-ui/core";

import ProductImage from "../ProductImage";
import LocalOfferPictoLong from "components/localOffer/assets/localOfferPictoLong.svg";
import { getProductEligibility } from "components/localOfferEligibility/LocalOfferEligibility";
import { OfferTag } from "ui/OfferTag/OfferTag";
import { isProductNew } from "../utils";
import { ProductStateTagWithInfo } from "ui/StateTag/StateTagWithInfo";

function ProductImageViewerDesktop({ pictureNew, images, product }) {
  const classes = useStyle();
  const [selectedImage, setSelectedImage] = useState(0);
  const [isNewSelected, setIsNewSelected] = useState(pictureNew ? true : false);
  // We get rid of broken links so that the maping does not
  // includes empty blocks
  const [brokenImages, setBrokenImages] = useState([]);

  const filteredImages = images.filter((image) => !brokenImages.includes(image));
  return (
    <Grid container direction="row" wrap="nowrap" spacing={2}>
      <Grid item xs={2}>
        <Box className={classes.previewItemContainer}>
          {pictureNew && (
            <Box
              key={pictureNew}
              onClick={() => setIsNewSelected(true)}
              onMouseEnter={() => setIsNewSelected(true)}
              className={classes.previewItem}
            >
              <Box
                position="absolute"
                left="50%"
                right="50%"
                bgcolor="secondary.main"
                bottom={0}
                height={5}
                className={`${classes.borderAnim} ${isNewSelected ? classes.borderDisplay : null}`}
              />

              <ProductImage
                hideShape
                src={pictureNew}
                number={0}
                product={product}
                width="100%"
                maxWidth={120}
                placeholder={null}
                propagateError={(src) =>
                  setBrokenImages((prev) => {
                    return [...prev, src];
                  })
                }
                addBrightness={false}
                zoomOnDesktop={false}
                zoomOnMobile={false}
                offerTag={undefined}
                productStateTag={undefined}
              />
            </Box>
          )}

          {filteredImages.map((image, index) => {
            return (
              <Box
                key={image}
                onClick={() => {
                  setIsNewSelected(false);
                  setSelectedImage(index);
                }}
                onMouseEnter={() => {
                  setIsNewSelected(false);
                  setSelectedImage(index);
                }}
                className={classes.previewItem}
              >
                <Box
                  position="absolute"
                  left="50%"
                  right="50%"
                  bgcolor="secondary.main"
                  bottom={0}
                  height={5}
                  className={`${classes.borderAnim} ${
                    selectedImage === index && !isNewSelected ? classes.borderDisplay : null
                  }`}
                />

                <ProductImage
                  hideShape
                  src={image}
                  number={index + 1}
                  product={product}
                  width="100%"
                  maxWidth={120}
                  placeholder={null}
                  propagateError={(src) =>
                    setBrokenImages((prev) => {
                      return [...prev, src];
                    })
                  }
                  addBrightness={false}
                  zoomOnDesktop={false}
                  zoomOnMobile={false}
                  offerTag={undefined}
                  productStateTag={undefined}
                />
              </Box>
            );
          })}
        </Box>
      </Grid>
      <Grid item xs={10}>
        <ProductImage
          hideShape={true}
          zoomOnDesktop={!isNewSelected}
          src={isNewSelected ? pictureNew : filteredImages[selectedImage]}
          width="100%"
          product={product}
          maxWidth={700}
          offerTag={getProductEligibility(product) && <OfferTag label="" picto={LocalOfferPictoLong()} />}
          propagateError={undefined}
          placeholder={undefined}
          addBrightness={false}
          zoomOnMobile={false}
          productStateTag={<ProductStateTagWithInfo isStateNew={isProductNew(product)} />}
        />
      </Grid>
    </Grid>
  );
}

const useStyle = makeStyles((theme) => ({
  image: {
    width: "100%",
    lineHeight: 0,
  },
  previewItemContainer: {
    maxHeight: "600px",
    overflow: "scroll",
  },
  previewItem: {
    position: "relative",
    cursor: "pointer",
    width: "100%",
    paddingBottom: "10px",
  },
  borderAnim: {
    marginBottom: 5,
    transition: "all 250ms ease-in-out",
    "&:hover": {
      left: theme.spacing(0.5),
      right: theme.spacing(0.5),
    },
  },
  borderDisplay: {
    zIndex: 2,
    left: theme.spacing(0.5),
    right: theme.spacing(0.5),
  },
}));

export default ProductImageViewerDesktop;
